import React, { useState } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import axios from 'axios';

export default function Challenge({ userId }) {
  const [challenge, setChallenge] = useState(null);
  const [loading, setLoading] = useState(false);
  const [swiped, setSwiped] = useState(null);

  const x = useMotionValue(0);
  const rotate = useTransform(x, [-200, 200], [-20, 20]);
  const opacity = useTransform(x, [-200, -100, 0, 100, 200], [0, 1, 1, 1, 0]);
  const background = useTransform(
    x,
    [-200, 0, 200],
    [
      'rgba(255,107,107,0.15)',
      'rgba(255,255,255,0.8)',
      'rgba(72,199,116,0.15)',
      
    ]
  );

  const fetchChallenge = async () => {
    setLoading(true);
    setChallenge(null);
    setSwiped(null);
    try {
      const res = await axios.post('https://recallcode-backend.onrender.com/challenge', {
        user_id: userId,
      });
      setChallenge(res.data.challenge);
    } catch (e) {
      setChallenge('Could not load challenge. Is the backend running?');
    }
    setLoading(false);
  };

  const handleDragEnd = (_, info) => {
    if (info.offset.x > 100) {
      animate(x, 500, { duration: 0.3 });
      setSwiped('right');
    } else if (info.offset.x < -100) {
      animate(x, -500, { duration: 0.3 });
      setSwiped('left');
    } else {
      animate(x, 0, { duration: 0.3 });
    }
  };

  return (
    <div>
      <motion.div
        className="glass-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <h2>🎯 Your Personalised Challenge</h2>
        <p style={{ marginBottom: 20 }}>
          Based on your past mistakes, RecallCode picks the perfect problem for you.
          Swipe right to attempt, swipe left to skip.
        </p>

        {!challenge && !loading && (
          <button className="btn-primary" onClick={fetchChallenge}>
            ✨ Generate My Challenge
          </button>
        )}

        {loading && <div className="loading">Finding your perfect challenge...</div>}

        {challenge && !loading && swiped === null && (
          <div className="swipe-container">
            <motion.div
              className="swipe-card"
              style={{ x, rotate, opacity, background }}
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              onDragEnd={handleDragEnd}
              whileDrag={{ scale: 1.03 }}
            >
              <div className="tag">🧠 Personalised for you</div>
              <p style={{
                fontSize: 15,
                lineHeight: 1.7,
                color: '#1a1a1a',
                whiteSpace: 'pre-wrap'
              }}>
                {challenge}
              </p>
              <div className="swipe-hint">
                <span>← Skip</span>
                <span>Attempt →</span>
              </div>
            </motion.div>
          </div>
        )}

        {swiped === 'right' && (
          <motion.div
            className="feedback-box"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
          >
            <p style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>
              🚀 Go for it!
            </p>
            <p style={{ whiteSpace: 'pre-wrap' }}>{challenge}</p>
            <p style={{ marginTop: 12, color: '#2d9e5f', fontSize: 13 }}>
              Submit your solution in the Mentor tab when ready!
            </p>
          </motion.div>
        )}

        {swiped === 'left' && (
          <motion.div
            className="feedback-box"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <p>No worries! Generating a new one...</p>
            <button
              className="btn-primary"
              onClick={fetchChallenge}
              style={{ marginTop: 12 }}
            >
              🔄 New Challenge
            </button>
          </motion.div>
        )}

        {challenge && swiped === null && (
          <button
            className="btn-primary"
            onClick={fetchChallenge}
            style={{ marginTop: 12 }}
          >
            🔄 Different Challenge
          </button>
        )}
      </motion.div>
    </div>
  );
}